import { MerchantDetail, MerchantShoppingType } from 'lib/shop/types';
import Image from 'next/image';
import React from 'react';

export default function MerchantTitle({
  merchant,
}: {
  merchant: MerchantDetail;
}) {
  return (
    <div className="mb-2 flex flex-row items-center justify-start space-x-5">
      <div className="relative h-[80px] w-[80px] overflow-hidden rounded-full ring ring-black ring-opacity-10">
        <Image
          alt={`${merchant.title} Logo`}
          src={merchant.logo_image?.url ?? ''}
          width={80}
          height={80}
          className="block"
        />
      </div>
      <div>
        <h2>{merchant.title}</h2>
        {merchant.shopping_types && merchant.shopping_types.length > 0 ? (
          <div className="mt-1.5 flex items-center">
            {/* Commented out until greener defines what to do with them. */}
            {/* {merchant.is_supergreen ? (
            <Medal className="mr-1 w-3.5 h-3.5" />
          ) : null} */}
            <div>
              {/* Commented out until greener defines what to do with them. */}
              {/* {merchant.is_supergreen ? (
              <span className="h7">Supergreen · </span>
            ) : null} */}
              <span className="p5">
                {merchant.shopping_types
                  .map(item => {
                    return `${MerchantShoppingType[item]}${
                      merchant.shopping_types.length > 1 ? '' : ' only'
                    }`;
                  })
                  .join(' & ')}{' '}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
